module.exports = __webpack_public_path__ + "img/press-mic.7c11578.webp";